import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { DeckViewer } from '@/components/DeckViewer'
import { getDeckMeta } from '@/decks/registry'

// Bare, non-interactive render of a deck's first slide. Mounted inside an
// iframe by the home-page thumbnails — no auth gate, no comments, no presence,
// so it stays light enough to run many at once. The iframe gives each render
// its own viewport so the decks' vw/vh-based CSS lays out at desktop scale.
export function PreviewPage() {
  const { slug } = useParams<{ slug: string }>()
  const theme = slug ? getDeckMeta(slug)?.defaultTheme ?? 'light' : 'light'

  useEffect(() => {
    document.body.setAttribute('data-theme', theme)
    document.body.setAttribute('data-deck-preview', '')
    return () => {
      document.body.removeAttribute('data-theme')
      document.body.removeAttribute('data-deck-preview')
    }
  }, [theme])

  if (!slug) return null
  return <DeckViewer slug={slug} initialSlide={0} />
}
